import { type Common } from './common.js';
import {
  type CareProviderWithAddress,
  type CreateValues,
  type FindAllOptions,
} from './models/careProvider.js';

interface BulkUpsertResponse {
  attempts: number;
  errors: string[];
}

export class API {
  common: Common;
  baseEndpoint = '/care-providers';

  constructor(common: Common) {
    this.common = common;
  }

  async findSuggestions(
    partialDisplayName: string,
    authenticationCode?: string
  ): Promise<CareProviderWithAddress[]> {
    const url = this.common.constructPath('/patient-previsit/care-providers', {
      partialDisplayName,
      authenticationCode,
    });
    return await this.common.getJSON(url);
  }

  async search(args: {
    input: string;
    requireNpi?: boolean;
    searchNpi?: boolean;
  }): Promise<CareProviderWithAddress[]> {
    const { input, requireNpi, searchNpi } = args;
    const url = this.common.constructPath(`${this.baseEndpoint}/search`, {
      input,
      requireNpi,
      searchNpi,
    });
    return await this.common.getJSON(url);
  }

  async bulkUpsert(careProviders: CreateValues[]): Promise<BulkUpsertResponse> {
    const url = this.common.constructPath(this.baseEndpoint);
    return await this.common.putJSON(url, {
      careProviders,
    });
  }

  async findAll(options: FindAllOptions = {}): Promise<CareProviderWithAddress[]> {
    const url = this.common.constructPath(this.baseEndpoint, options);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<CareProviderWithAddress> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }
}
